import { render, staticRenderFns } from "./bigCustomerInfo.vue?vue&type=template&id=515f4946"
import script from "./bigCustomerInfo.vue?vue&type=script&lang=js"
export * from "./bigCustomerInfo.vue?vue&type=script&lang=js"
import style0 from "./bigCustomerInfo.vue?vue&type=style&index=0&id=515f4946&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports